import React from 'react'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import DisbursementChecklistViewSF from '../../../components/superUser/loan/DisbursementChecklistViewSF'

const LoanDisbursementChecklistPageUI = ({ context, errorList, loan, onRefreshClick }) =>
  <SuperUserLoanPageUI context={context} className='pg_su_loan_disb_checklist'
    backLink={`/su/loans${loan && (loan.status === 'closed' ? '/closed' : (loan.status === 'disbursed' ? '/disbursed' : ''))}`}
    headerText={loan ? (loan.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='disbursement_checklist' dimension='w768'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <div>
        <DisbursementChecklistViewSF
          context={context}
          loan={loan}
          onChecklistGenerated={onRefreshClick}
        />
      </div>
    }
  </SuperUserLoanPageUI>

export default LoanDisbursementChecklistPageUI